import { get } from 'lodash';

export const getFlowMetrics = (flowMeta: any) => {
  if (!flowMeta || !flowMeta.metricsMeta) return [];
  const { metrics, metricsMeta } = flowMeta;

  try {
    return [
      ...new Set(
        Object.values(metrics).reduce((acc: string[], metricKey: any) => {
          const percentageMetric = get(metricsMeta[metricKey], 'percentageMetric', null);
          acc.push(metricKey);
          if (percentageMetric) {
            acc.push(percentageMetric);
          }
          return acc;
        }, [] as string[]),
      ),
    ];
  } catch (error) {
    console.error('Error getting flow metrics:', error);
    return [];
  }
};
